;(function () {
  'use strict';

  class AddedToCartMessage {
    constructor() {
      this.wrapper = document.createElement('div');
      this.wrapper.classList.add(
        'added-to-cart-message-wrapper',
        'added-to-cart-message-wrapper-hidden'
      );
      document.body.append(this.wrapper);

      this.wrapper.addEventListener('click', event => {
        if (event.target === event.currentTarget) {
          this.close();
        }
      });

      document.addEventListener('keyup', event => {
        if (event.key === 'Escape') {
          this.close();
        }
      });

      this._preRender();
    }

    // `data` should be JSON result responded from `/cart/add.js`.
    show(data) {
      while (this.items.hasChildNodes()) {
        this.items.removeChild(this.items.lastChild);
      }

      data.items.forEach(item => {
        const itemElement = document.createElement('div');
        itemElement.classList.add('added-to-cart-message-item');

        const image = document.createElement('img');
        image.classList.add('added-to-cart-message-item-image');
        image.src = item.image + '&width=150';

        const info = document.createElement('div');
        info.classList.add('added-to-cart-message-item-info');

        const title = document.createElement('div');
        title.classList.add('added-to-cart-message-item-title');
        title.textContent = item.title;

        const quantity = document.createElement('div');
        quantity.classList.add('added-to-cart-message-item-quantity');
        quantity.textContent = `Quantity: ${item.quantity}`;

        info.append(title, quantity);
        itemElement.append(image, info);
        this.items.append(itemElement);
      });

      this.wrapper.classList.remove('added-to-cart-message-wrapper-hidden');
    }

    close() {
      this.wrapper.classList.add('added-to-cart-message-wrapper-hidden');
    }

    _preRender() {
      const root = document.createElement('div');
      root.classList.add('added-to-cart-message');

      const closeButton = document.createElement('button');
      closeButton.classList.add('added-to-cart-message-close-button');
      closeButton.type = 'button';
      closeButton.textContent = '×';
      closeButton.addEventListener('click', () => this.close());

      const header = document.createElement('div');
      header.classList.add('added-to-cart-message-header');
      header.textContent = 'Added Following Items to Cart';

      this.items = document.createElement('div');
      this.items.classList.add('added-to-cart-message-items');

      const buttons = document.createElement('div');
      buttons.classList.add('added-to-cart-message-action-buttons');

      const viewCartButton = document.createElement('a');
      viewCartButton.classList.add('added-to-cart-message-view-cart-button', 'btn');
      viewCartButton.href = window.Shopify.routes.root + 'cart';
      viewCartButton.textContent = 'View Cart';

      const continueShoppingButton = document.createElement('button');
      continueShoppingButton.classList.add('added-to-cart-message-continue-shopping-button', 'btn');
      continueShoppingButton.type = 'button';
      continueShoppingButton.addEventListener('click', () => this.close());
      continueShoppingButton.textContent = 'Continue Shopping';

      buttons.append(viewCartButton, continueShoppingButton);
      root.append(closeButton, header, this.items, buttons);
      this.wrapper.append(root);
    }
  }

  window.Shopify.theme.addedToCartMessage = new AddedToCartMessage();
})();
